import { Component, Input } from '@angular/core';

@Component({
  selector: 'adc-alert',
  templateUrl: './adc-alert.component.html',
  styleUrls: ['./adc-alert.component.scss'],
  standalone: false
})
export class AdcAlertComponent {
  @Input('type') type: string = 'message';
  @Input('theme') theme: any;
  @Input('data') data: any;
}
